module.exports = __webpack_public_path__ + "static/bee-nano-bbe1ca1fb9abb4867e9a2912ddff9d81.jpg";